// Khazanah portfolio data.
// EBITDA opportunity is computed at render time as asbc_gap * 0.6.

export const KHAZANAH_COMPANIES = [
  {
    id: "mas",
    name: "Malaysia Airlines",
    sector: "Aviation",
    headcount: 14000,
    asbc_gap: 340000000,
    labour_cost: 980000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/mas-khazanah-2026",
    signal: "red",
    urgency_reason: "Sector peers restructuring 2.1x faster",
    functions: [
      "Flight Operations",
      "Ground Services",
      "Engineering & MRO",
      "Commercial",
      "Digital & IT",
      "HR & People",
    ],
    competitors: [
      { name: "Malaysia Airlines", score: 34, isTarget: true },
      { name: "Singapore Airlines", score: 71 },
      { name: "Emirates", score: 78 },
      { name: "Air Asia", score: 52 },
      { name: "Cathay Pacific", score: 61 },
    ],
    velocity_headline: "Sector peers restructuring 2.1\u00d7 faster",
    leadership_scores: [5, 6, 4, 3, 4, 5, 5],
    readiness_score: 69,
    readiness_drivers: [
      "Restructuring velocity 2.1\u00d7 below sector peers",
      "Digital & AI leadership capability at 3/10",
      "Engineering & MRO function at high automation risk",
    ],
  },
  {
    id: "ihh",
    name: "IHH Healthcare",
    sector: "Healthcare",
    headcount: 65000,
    asbc_gap: 520000000,
    labour_cost: 2100000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/ihh-khazanah-2026",
    signal: "red",
    urgency_reason: "AI disruption accelerating in clinical operations",
    functions: [
      "Clinical Operations",
      "Nursing",
      "Administration",
      "Digital Health",
      "Finance",
      "HR & People",
    ],
    competitors: [
      { name: "IHH Healthcare", score: 41, isTarget: true },
      { name: "Parkway Pantai", score: 58 },
      { name: "Columbia Asia", score: 63 },
      { name: "KPJ Healthcare", score: 55 },
      { name: "Raffles Medical", score: 67 },
    ],
    velocity_headline: "AI adoption in clinical ops 1.6\u00d7 faster at peers",
    leadership_scores: [7, 7, 6, 5, 6, 7, 6],
    readiness_score: 56,
    readiness_drivers: [
      "Clinical AI adoption lagging regional peers",
      "Strong leadership depth partially offset by digital capability gap",
      "65,000 workforce presents significant scale opportunity",
    ],
  },
  {
    id: "axiata",
    name: "Axiata Group",
    sector: "Telecommunications",
    headcount: 11000,
    asbc_gap: 220000000,
    labour_cost: 650000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/axiata-khazanah-2026",
    signal: "amber",
    urgency_reason: "Digital transformation stalling vs peers",
    functions: [
      "Network Operations",
      "Technology",
      "Commercial",
      "Digital Services",
      "Finance",
      "HR & People",
    ],
    competitors: [
      { name: "Axiata Group", score: 48, isTarget: true },
      { name: "Maxis", score: 69 },
      { name: "Digi/CelcomDigi", score: 72 },
      { name: "Telkom Indonesia", score: 61 },
      { name: "Singtel", score: 83 },
    ],
    velocity_headline: "Digital transformation velocity below sector median",
    leadership_scores: [6, 5, 7, 6, 5, 6, 6],
    readiness_score: 48,
    readiness_drivers: [
      "Digital transformation stalling vs Singtel benchmark",
      "Network operations high BOT potential untapped",
      "Leadership strategy alignment moderate",
    ],
  },
  {
    id: "tm",
    name: "Telekom Malaysia",
    sector: "Telecommunications",
    headcount: 22000,
    asbc_gap: 156000000,
    labour_cost: 580000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/tm-khazanah-2026",
    signal: "amber",
    urgency_reason: "Workforce cost structure above sector median",
    functions: [
      "Network & Infrastructure",
      "Technology",
      "Customer Operations",
      "Commercial",
      "Finance",
      "HR & People",
    ],
    competitors: [
      { name: "Telekom Malaysia", score: 44, isTarget: true },
      { name: "Maxis", score: 69 },
      { name: "TIME dotCom", score: 73 },
      { name: "CelcomDigi", score: 72 },
      { name: "Singtel", score: 83 },
    ],
    velocity_headline: "Workforce cost structure 18% above sector median",
    leadership_scores: [5, 7, 4, 4, 5, 5, 5],
    readiness_score: 52,
    readiness_drivers: [
      "Workforce cost structure 18% above sector median",
      "Infrastructure roles facing automation pressure",
      "Succession depth below sector benchmark",
    ],
  },
  {
    id: "cimb",
    name: "CIMB Group",
    sector: "Banking & Financial Services",
    headcount: 33000,
    asbc_gap: 290000000,
    labour_cost: 1200000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/cimb-khazanah-2026",
    signal: "red",
    urgency_reason: "Fintech competitors restructuring at 3x velocity",
    functions: [
      "Retail Banking",
      "Corporate Banking",
      "Technology & Digital",
      "Risk & Compliance",
      "Finance",
      "HR & People",
    ],
    competitors: [
      { name: "CIMB Group", score: 38, isTarget: true },
      { name: "Maybank", score: 61 },
      { name: "RHB Bank", score: 55 },
      { name: "Public Bank", score: 49 },
      { name: "GXBank (fintech)", score: 89 },
    ],
    velocity_headline: "Fintech competitors restructuring at 3\u00d7 velocity",
    leadership_scores: [7, 6, 7, 6, 6, 7, 7],
    readiness_score: 65,
    readiness_drivers: [
      "Fintech competitors restructuring at 3\u00d7 velocity",
      "Risk & Compliance function over-resourced vs optimal",
      "Strong leadership composite partially offset by transformation inertia",
    ],
  },
];
